import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Banner from '../../components/Banner/Banner';
import Solutions from '../../components/Solutions/Solutions';
import Join from '../../components/Join/Join';
import Footer from '../../components/Footer/Footer';
import ContactSection from '../../components/ContactSection/ContactSection';
import './Home.css';
import { 
  FaChartLine, 
  FaDatabase, 
  FaChartBar, 
  FaChartPie,
  FaExchangeAlt,
  FaServer,
  FaRobot,
  FaMicrochip
} from 'react-icons/fa';
const CompanyIntro = () => {
  return (
    <div className="pt-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-left">
          <p className="text-lg text-gray-700 leading-relaxed" style={{textIndent: '2em'}}>
          河北视动科技有限公司是一家致力于推动企业数字化转型、赋能商业创新发展的综合性科技公司。公司凭借领先的数据分析能力、智能化软件产品以及高效的行业解决方案，持续助力房地产、金融投资、企业风控等领域的数字化转型升级。依托强大的综合类大数据分析系统、精准的房地产市场洞察系统以及可视化数据展示工具，我们为客户提供定制化的商业智能解决方案，助力企业实现精细化运营与科学决策。河北视动科技拥有一支由资深数据分析师和软件工程师组成的专业团队，持续创新，不断优化产品与服务，致力于为客户创造可持续的商业价值和竞争优势。
          </p>
        </div>
      </div>
    </div>
  );
};
const Home = () => {
  const solutionsCards = {
    title: "软件解决方案",
    subtitle: "Services",
    cards: [
      {
        icon: <FaChartLine className="w-12 h-12" style={{ color: 'var(--primary-color)' }} />,
        title: '综合类大数据与分析系统',
        description: '通过结构化和非结构化模型从不同形式的数据中提取洞察，为企业增加价值。',
        path: '/trade'
      },
      {
        icon: <FaDatabase className="w-12 h-12" style={{ color: 'var(--primary-color)' }} />,
        title: '房产市场洞察与投资分析系统',
        description: '强大、可扩展且经济实惠的数据仓库系统，使组织能够在数千用户之间共享海量数据。',
        path: '/customs'
      },
      {
        icon: <FaChartBar className="w-12 h-12" style={{ color: 'var(--primary-color)' }} />,
        title: '投资与风险管理类系统',
        description: '通过特定的系统和软件分析数据集，以得出关于信息的结论。',
        path: '/investment'
      },
      {
        icon: <FaChartPie className="w-12 h-12" style={{ color: 'var(--primary-color)' }} />,
        title: '数据可视化与展示类系统',
        description: '数据可视化在应对挑战方面发挥最佳作用，帮助与各类受众进行科学输出交互。',
        path: '/stock'
      }
    ]
  };


  return (
    <div className="home flex flex-col min-h-screen">
      <Navbar />
      <Banner />
      <CompanyIntro />
      <Solutions {...solutionsCards} />
      {/* <Join /> */}
      <ContactSection />

      <div className='mt-auto' style={{backgroundColor: '#f8f9fa'}} >
        <div className='container'>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Home; 